import { createAction } from '../../../store.model';
import { TemplateConfig } from '../../core/config.scorecard.model';
import { ScorecardGridOptions } from '../../core/scorecard-grid-options.model';
import { SortOrder } from '../../experimental.grid';
import {
    PillarAndMetricResult,
    ScorecardAttributes,
    ScorecardDto,
} from '../../scorecard.model';

import { DirectReportContributionResult } from './direct-report-contribution-grid.model';
import { DirectReportRankResult } from './direct-report-rank-grid.model';
import { DirectReportScorecardResult } from './direct-report-scorecard-grid.model';
import { FilterPillar } from './team-grid.model';

export enum ActionType {
    DIRECTREPORT_CONTRIBUTION_GRID__RELOAD = 'DIRECTREPORT_CONTRIBUTION_GRID__RELOAD',
    DIRECTREPORT_CONTRIBUTION_GRID__SORT = 'DIRECTREPORT_CONTRIBUTION_GRID__SORT',
    DIRECTREPORT_CONTRIBUTION_GRID__FILTER = 'DIRECTREPORT_CONTRIBUTION_GRID__FILTER',
    DIRECTREPORT_CONTRIBUTION_GRID_PILLAR__FILTER = 'DIRECTREPORT_CONTRIBUTION_GRID_PILLAR__FILTER',
    DIRECT_REPORT_CONTRIBUTION_GRID_RESET = 'DIRECT_REPORT_CONTRIBUTION_GRID_RESET',

    DIRECTREPORT_RANK_GRID__RELOAD = 'DIRECTREPORT_RANK_GRID__RELOAD',
    DIRECTREPORT_RANK_GRID__SORT = 'DIRECTREPORT_RANK_GRID__SORT',
    DIRECTREPORT_RANK_GRID__FILTER = 'DIRECTREPORT_RANK_GRID__FILTER',
    DIRECT_REPORT_RANK_GRID_RESET = 'DIRECT_REPORT_RANK_GRID_RESET',

    DIRECTREPORT_SCORECARD_GRID__RELOAD = 'DIRECTREPORT_SCORECARD_GRID__RELOAD',
    DIRECTREPORT_SCORECARD_GRID__SORT = 'DIRECTREPORT_SCORECARD_GRID__SORT',
    DIRECTREPORT_SCORECARD_GRID__FILTER = 'DIRECTREPORT_SCORECARD_GRID__FILTER',
    DIRECTREPORT_SCORECARD_GRID_PILLAR__FILTER = 'DIRECTREPORT_SCORECARD_GRID_PILLAR__FILTER',
    DIRECT_REPORT_SCORECARD_GRID_RESET = 'DIRECT_REPORT_SCORECARD_GRID_RESET',
    DIRECTREPORT_EXPAND_SCORECARDMETRICCOLUMNS = 'DIRECTREPORT_EXPAND_SCORECARDMETRICCOLUMNS',
    DIRECTREPORT_SCORECARD_EXPAND_ALL = 'DIRECTREPORT_SCORECARD_EXPAND_ALL',
    DIRECTREPORT_EXPAND_ALL = 'DIRECTREPORT_EXPAND_ALL',
    DIRECTREPORT_EXPAND_METRICCOLUMNS = 'DIRECTREPORT_EXPAND_METRICCOLUMNS',
}

export interface ContributionReload {
    options: ScorecardGridOptions;
    tplConfig: TemplateConfig;
    header: ScorecardDto;
    data: PillarAndMetricResult[];
    attributes: ScorecardAttributes[];
    directReportContributionGrid?: DirectReportContributionResult[];
    directReportRankGrid?: DirectReportRankResult[];
}

export interface ExpandAll {
    expand: boolean;
}

export interface ExpandMetricColumns {
    columnId: string;
}

export interface ExpandScorecardMetricColumns {
    columnId: string;
}

export interface RankReload {
    options: ScorecardGridOptions;
    tplConfig: TemplateConfig;
    header: ScorecardDto;
    data: PillarAndMetricResult[];
    attributes: ScorecardAttributes[];
    directReportRankGrid?: DirectReportRankResult[];
    directReportContributionGrid?: DirectReportContributionResult[];
}

export interface SortContributionGrid {
    columnId: string;
}

export interface ContributionGridExport {
    headerList: string[];
}

export interface SortDirectReportRankGrid {
    columnId: string;
    order?: SortOrder;
    keepOrder?: boolean;
}

export interface SortDirectReportContributionGrid {
    columnId: string;
    order?: SortOrder;
    keepOrder?: boolean;
}

export interface SortDirectReportScorecardGrid {
    columnId: string;
    order?: SortOrder;
    keepOrder?: boolean;
}

export interface FilterDirectReportRankGrid {
    /** set to null to reset */
    payload: FilterPillar[];
}

export interface FilterDirectReportContributionGrid {
    /** set to null to reset */
    payload: FilterPillar[];
}

export interface FilterDirectReportGridPillar {
    /** set to null to reset */
    payload: FilterPillar[];
}

export interface FilterDirectReportScorecardGrid {
    /** set to null to reset */
    payload: FilterPillar[];
}

export interface ScorecardReload {
    options: ScorecardGridOptions;
    tplConfig: TemplateConfig;
    header: ScorecardDto;
    data: PillarAndMetricResult[];
    attributes: ScorecardAttributes[];
    directReportContributionGrid?: DirectReportContributionResult[];
    directReportRankGrid?: DirectReportRankResult[];
    directReportScorecardGrid?: DirectReportScorecardResult[];
}

export interface RankGridExport {
    headerList: string[];
}

export interface ScorecardGridExport {
    headerList: string[];
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface RankGridReset {}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ContributionGridReset {}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface DRScorecardGridReset {}

export const expandAll = createAction<ActionType, ExpandAll>(
    ActionType.DIRECTREPORT_EXPAND_ALL,
);
export const expandMetricColumns = createAction<
    ActionType,
    ExpandMetricColumns
>(ActionType.DIRECTREPORT_EXPAND_METRICCOLUMNS);
export const contributionReload = createAction<ActionType, ContributionReload>(
    ActionType.DIRECTREPORT_CONTRIBUTION_GRID__RELOAD,
);
export const filterDirectReportContributionGridPillar = createAction<
    ActionType,
    FilterDirectReportGridPillar
>(ActionType.DIRECTREPORT_CONTRIBUTION_GRID_PILLAR__FILTER);
export const filterDirectReportContributionGrid = createAction<
    ActionType,
    FilterDirectReportContributionGrid
>(ActionType.DIRECTREPORT_CONTRIBUTION_GRID__FILTER);
export const sortDirectReportContributionGrid = createAction<
    ActionType,
    SortDirectReportContributionGrid
>(ActionType.DIRECTREPORT_CONTRIBUTION_GRID__SORT);
export const contributionGridReset = createAction<
    ActionType,
    ContributionGridReset
>(ActionType.DIRECT_REPORT_CONTRIBUTION_GRID_RESET);

export const rankReload = createAction<ActionType, RankReload>(
    ActionType.DIRECTREPORT_RANK_GRID__RELOAD,
);
export const rankGridReset = createAction<ActionType, RankGridReset>(
    ActionType.DIRECT_REPORT_RANK_GRID_RESET,
);

export const sortDirectReportRankGrid = createAction<
    ActionType,
    SortDirectReportRankGrid
>(ActionType.DIRECTREPORT_RANK_GRID__SORT);
export const filterDirectReportRankGrid = createAction<
    ActionType,
    FilterDirectReportRankGrid
>(ActionType.DIRECTREPORT_RANK_GRID__FILTER);
export const scorecardReload = createAction<ActionType, ScorecardReload>(
    ActionType.DIRECTREPORT_SCORECARD_GRID__RELOAD,
);
export const sortDirectReportScorecardGrid = createAction<
    ActionType,
    SortDirectReportScorecardGrid
>(ActionType.DIRECTREPORT_SCORECARD_GRID__SORT);
export const filterDirectReportScorecardGrid = createAction<
    ActionType,
    FilterDirectReportScorecardGrid
>(ActionType.DIRECTREPORT_SCORECARD_GRID__FILTER);
export const filterDirectReportScorecardGridPillar = createAction<
    ActionType,
    FilterDirectReportGridPillar
>(ActionType.DIRECTREPORT_SCORECARD_GRID_PILLAR__FILTER);
export const expandScorecardMetricColumns = createAction<
    ActionType,
    ExpandScorecardMetricColumns
>(ActionType.DIRECTREPORT_EXPAND_SCORECARDMETRICCOLUMNS);
export const expandAllScorecard = createAction<ActionType, ExpandAll>(
    ActionType.DIRECTREPORT_SCORECARD_EXPAND_ALL,
);
export const drScorecardGridReset = createAction<
    ActionType,
    DRScorecardGridReset
>(ActionType.DIRECT_REPORT_SCORECARD_GRID_RESET);
